import {FC} from 'react'
import {AdminFranchise} from '../../../core/_models'

type Props = {
  franchise: AdminFranchise
}

const DocumentCell: FC<Props> = ({franchise}) => (
  <span>{franchise.person?.juridicalPerson?.cnpj ?? '-'}</span>
)

export {DocumentCell}
